<form class="calibrates-theme">

  <mat-card class="card">
    <mat-card-content>
      <mat-toolbar color="secondary">
        {{ 'internalEquipmentEdit.equipment.data.title' | translate }}
      </mat-toolbar>

      <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'internalEquipmentEdit.general.name.label' | translate }}</mat-label>
            <input matInput name="nameEq" [(ngModel)]="equipment.name" required [disabled]="pendingReview">
            <mat-error>
              {{ 'internalEquipmentEdit.general.name.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        @if (isInternal) {
          <div fxFlex="50" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'internalEquipmentEdit.general.group.label' | translate }}</mat-label>
              <input matInput name="group" [(ngModel)]="equipment.group" [disabled]="pendingReview">
            </mat-form-field>
          </div>
        }

        @if (!isInternal) {
        <div fxFlex="50" fxFlex.lt-md="100%"></div>
        }

        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'internalEquipmentEdit.general.equipment.label' | translate }}</mat-label>
            <input matInput name="equipment" [(ngModel)]="equipment.equipment" required [disabled]="pendingReview">
            <mat-error>
              {{ 'internalEquipmentEdit.general.equipment.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'internalEquipmentEdit.general.maker.label' | translate }}</mat-label>
            <input matInput name="maker" [(ngModel)]="equipment.maker" required [disabled]="pendingReview">
            <mat-error>
              {{ 'internalEquipmentEdit.general.maker.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'internalEquipmentEdit.general.model.label' | translate }}</mat-label>
            <input matInput name="model" [(ngModel)]="equipment.model" required [disabled]="pendingReview">
            <mat-error>
              {{ 'internalEquipmentEdit.general.model.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'internalEquipmentEdit.general.serialNum.label' | translate }}</mat-label>
            <input matInput name="serialNum" [(ngModel)]="equipment.serialNum" required [disabled]="pendingReview">
            <mat-error>
              {{ 'internalEquipmentEdit.general.serialNum.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        @if (isExternal) {
        <div fxFlex="50" fxFlex.lt-md="100%" class="select-container">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'internalEquipmentEdit.general.client.label' | translate }}</mat-label>
            <mat-select #clientSelect name="idClient" [(ngModel)]="equipment.idClient" [required]="isExternal" [disabled]="pendingReview">
              @if (clientSelect.focused) {
              <mat-select-filter [displayMember]="'name'" [array]="clients" (filteredReturn)="clientsFiltered =$event"
                [noResultsMessage]="'common.noResults' | translate"></mat-select-filter>
              }
              @for (client of clientsFiltered; track client) {
              <mat-option [value]="client.id">
                {{client.name}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }

        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'internalEquipmentEdit.general.location.label' | translate }}</mat-label>
            <input matInput name="location" [(ngModel)]="equipment.location" [disabled]="pendingReview">
            <!--<mat-error>
            {{ 'internalEquipmentEdit.general.location.error' | translate }}
          </mat-error>-->
          </mat-form-field>
        </div>

        <div fxFlex="50" fxFlex.lt-md="100%" class="select-container">
          <mat-form-field class="campoFormulario" matTooltip="{{'calibrationPlan.contactUs.tooltip'| translate }}"
            [matTooltipDisabled]="hasCalibrationPlan()">
            <mat-label>{{'internalEquipmentEdit.general.acquisitionDate.label' | translate }}</mat-label>
            <input matInput [matDatepicker]="acquisitionDate" (focus)="acquisitionDate?.open()" name="acquisitionDate"
              [(ngModel)]="equipment.acquisitionDate" (blur)="saveDateField('acquisitionDate', $event)"
              (dateChange)="saveDateField('acquisitionDate', $event)" [disabled]="!hasCalibrationPlan() || pendingReview">
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="acquisitionDate"></mat-datepicker-toggle>
            <mat-datepicker #acquisitionDate>
            </mat-datepicker>
          </mat-form-field>
        </div>

        @if (isInternal && equipment.id != null) {
        <div fxFlex="50" fxFlex.lt-md="100%" class="select-container">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'internalEquipmentEdit.general.status.label' | translate }}</mat-label>
            <mat-select #statusSelect name="idStatus" [ngModel]="equipment.idStatus" [required]="isInternal"  [disabled]="pendingReview"
              (selectionChange)="onChangeStatus($event)">
              <mat-option [value]="null"> --- </mat-option>
              @for (item of statuses; track item) {
              <mat-option [value]="item.id" [disabled]="!disabledByStatus(item.id)">
                {{ 'internalEquipmentStatus.' + item.translation | translate }}
              </mat-option>
              }
            </mat-select>
            <mat-error>
              {{ 'internalEquipmentEdit.general.status.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        }

        <div fxFlex="50" fxFlex.lt-md="100%" class="select-container">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'internalEquipmentEdit.general.equipmentTypes.label' | translate }}</mat-label>
            <mat-select [(ngModel)]="equipment.idEquipmentType" name="idEquipmentType" [disabled]="pendingReview"
              (selectionChange)="changeEquipmentType()">
              @for (item of internalEquipmentTypes; track item) {
              <mat-option checkboxPosition="before" [value]="item.id">
                {{ 'equipmentType.' + item.name | translate }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        @if (isInternal) {
        <div fxFlex="50" fxFlex.lt-md="100%" class="select-container">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'internalEquipmentEdit.general.appTypes.label' | translate }}</mat-label>
            <mat-select multiple [(ngModel)]="equipment.idsApps" name="idsApps" [disabled]="pendingReview">
              @for (item of appTypes; track item) {
              <mat-option checkboxPosition="before" [value]="item.id">
                {{ item.name | translate }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }

        <div fxFlex="50" fxFlex.lt-md="100%" class="select-container">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'internalEquipmentEdit.general.variables.label' | translate }}:</mat-label>
            <mat-select multiple [(ngModel)]="equipment.idsVariables" name="idsVariables" [disabled]="pendingReview">
              @for (item of variables; track item) {
              <mat-option checkboxPosition="before" [value]="item.id">
                {{ 'variable.' + item.translation | translate }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        @if (folders?.length > 0) {
        <div fxFlex="50" fxFlex.lt-md="100%" class="select-container">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'internalEquipmentEdit.general.folders.label' | translate }}</mat-label>
            <mat-select multiple [(ngModel)]="equipment.idsFolder" name="idsFolder" [disabled]="pendingReview">
              @for (item of folders; track item) {
              <mat-option checkboxPosition="before" [value]="item.id">
                {{ getFolderName(item) }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <div fxFlex="50" fxFlex.lt-md="100%" class="select-container">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'internalEquipmentEdit.general.actionTypes.label' | translate }}</mat-label>
            <mat-select multiple [(ngModel)]="idsActionSelected" name="idsAction" [disabled]="pendingReview"
              (ngModelChange)="onChangeActionType()">
              @for (item of actionTypes; track item) {
              <mat-option checkboxPosition="before" [value]="item.id">
                {{ 'internalEquipmentEdit.'+ item.translation | translate }}
              </mat-option>
              }
            </mat-select>
            <mat-error>
              {{ 'internalEquipmentEdit.general.actionTypes.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        @if (isManager || (pendingReview && equipment.responsibleEquipment)) {
        <div fxFlex="50" fxFlex.lt-md="100%">
          <div fxFlex="60" fxFlex.lt-md="100%" class="select-container">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'internalEquipmentEdit.general.resposible.equipment.label' | translate }}</mat-label>
              <mat-select #responsableSelect name="idResponsibleEquipment" [(ngModel)]="equipment.responsibleEquipment"
                [disabled]="pendingReview">
                @if (responsableSelect.focused) {
                <mat-select-filter [displayMember]="'fullName'" [array]="users" (filteredReturn)="usersFiltered =$event"
                  [noResultsMessage]="'common.noResults' | translate"></mat-select-filter>
                }
                @for (user of usersFiltered; track user) {
                <mat-option [value]="user.username">
                  {{user.fullName}}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          @if (isManager || (pendingReview && equipment.responsibleEquipment)) {
          <div fxFlex="40" fxFlex.lt-md="100%">
            <mat-checkbox [value]="equipment.notificationResposibleEq" [checked]="equipment.notificationResposibleEq" [disabled]="pendingReview"
              (change)="onChangeNotificationResponsible($event)">
              {{ 'internalEquipmentEdit.general.notification.resposible.equipment.label' | translate }}
            </mat-checkbox>
          </div>
          }
        </div>
        }

        <div fxFlex="20" fxFlex.lt-md="100%" style="align-content: center; padding: 10px;">
          <mat-checkbox name="multichannel" [(ngModel)]="equipment.multichannel" [disabled]="pendingReview">
            {{'internalEquipmentEdit.general.multichannel.label' | translate }}
          </mat-checkbox>
        </div>
      </div>

    </mat-card-content>
  </mat-card>

  @if (equipment.id && showCalibrationPlan()) {
  <mat-card class="card">
    <mat-card-content>
      <mat-toolbar color="secondary">
        {{ 'internalEquipmentEdit.other.data.title' | translate }}
      </mat-toolbar>
      <div fxLayout="row" fxLayout.xs="column" class="flexwrap" [hidden]="equipment.customFields == null">
        @for (field of equipment.customFields; track field; let indexField = $index) {
        <div fxFlex="50" fxFlex.lt-md="100%">
          <!-- STRING -->
          @if (field.idType == 1) {
          <div>
            <mat-form-field class="campoFormulario">
              <mat-label>{{ field.name }}</mat-label>
              <input matInput [name]="field.name" [(ngModel)]="field.value" [errorStateMatcher]="matcher" [disabled]="pendingReview"
                [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </div>
          }
          <!-- NUMÉRICO -->
          @if (field.idType == 2) {
          <div>
            <mat-form-field class="campoFormulario">
              <mat-label>{{ field.name }}</mat-label>
              <input matInput [name]="field.name" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" [disabled]="pendingReview"
                [errorStateMatcher]="matcher" (ngModelChange)="setValue(field, -1, $event)" type="number"
                [required]="field.required">
            </mat-form-field>
          </div>
          }
          <!-- TOLERANCIA -->
          @if (field.idType == 3) {
          <div>
            <div fxFlex="40%" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ field.name }}</mat-label>
                <input matInput [name]="field.name" [ngModelOptions]="{standalone: true}" [disabled]="pendingReview"
                  (ngModelChange)="setValue(field, 0, $event)" [errorStateMatcher]="matcher" type="number">
              </mat-form-field>
            </div>
            <div fxFlex="40%" fxFlex.lt-md="100%">
              ±
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'protocolEdit.dialog.essay.valueTolerance.label' | translate }}</mat-label>
                <input matInput [name]="field.name + 'Tolerance'" (ngModelChange)="setValue(field, 1, $event)" [disabled]="pendingReview"
                  [errorStateMatcher]="matcher" type="number" [ngModelOptions]="{standalone: true}">
              </mat-form-field>
            </div>
          </div>
          }
          <!-- BOOLEAN -->
          @if (field.idType == 8) {
          <div>
            <mat-checkbox [value]="field.value" [checked]="field.value == 'true'" [disabled]="pendingReview"
              (change)="setValue(field, -1, $event)">
              {{ field.name }}
            </mat-checkbox>
          </div>
          }
          <!-- SELECT ONE -->
          @if (field.idType == 6) {
          <div>
            <mat-form-field class="campoFormulario">
              <mat-label>{{ field.name }}</mat-label>
              <mat-select [name]="'idSelectCustom'+field.id" [(ngModel)]="field.value" [disabled]="pendingReview">
                @for (sel of field.valueSelect; track sel) {
                <mat-option [value]="sel.value">
                  {{sel.value}}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }
        </div>
        }
        @if (equipment.customFields?.length == 0) {
        <div fxFlex="50" fxFlex.lt-md="100%" style="margin-top: 2em;margin-bottom: 2em;">
          {{ 'protocolEdit.dialog.essay.fields.empty' | translate }}
        </div>
        }
      </div>
    </mat-card-content>
  </mat-card>
  }

  @if (isEdit || isInternal) {
  <mat-card class="card">
    <mat-card-content>
      <mat-toolbar color="secondary">
        {{ 'internalEquipmentEdit.dataGeneral.title' | translate }}
      </mat-toolbar>
      <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
        <mat-accordion style="width: 100%;">
          @if (isCalibration) {
          <mat-expansion-panel (opened)="isDataCalibrationOpened = true" (closed)="isDataCalibrationOpened = false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ 'internalEquipmentEdit.calibrationData.title' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
              @if (isInternal || equipmentCalibration.equipmentRange) {
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario" matTooltip="{{'calibrationPlan.contactUs.tooltip'| translate }}"
                  [matTooltipDisabled]="hasCalibrationPlan()">
                  <mat-label>{{ 'internalEquipmentEdit.general.equipmentRange.label' | translate }}</mat-label>
                  <input matInput name="equipmentRange" [(ngModel)]="equipmentCalibration.equipmentRange"
                    [disabled]="!hasCalibrationPlan() || !isInternal || pendingReview">
                </mat-form-field>
              </div>
              }
              @if (isInternal || equipmentCalibration.useRange) {
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario" matTooltip="{{'calibrationPlan.contactUs.tooltip'| translate }}"
                  [matTooltipDisabled]="hasCalibrationPlan()">
                  <mat-label>{{ 'internalEquipmentEdit.general.useRange.label'| translate }}</mat-label>
                  <input matInput name="useRange" [(ngModel)]="equipmentCalibration.useRange"
                    [disabled]="!hasCalibrationPlan() || !isInternal || pendingReview">
                </mat-form-field>
              </div>
              }
              @if (isInternal || equipmentCalibration.resolution) {
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario" matTooltip="{{'calibrationPlan.contactUs.tooltip'| translate }}"
                  [matTooltipDisabled]="hasCalibrationPlan()">
                  <mat-label>{{ 'internalEquipmentEdit.general.resolution.label'| translate }}</mat-label>
                  <input matInput name="resolution" [(ngModel)]="equipmentCalibration.resolution"
                    [disabled]="!hasCalibrationPlan() || !isInternal || pendingReview">
                </mat-form-field>
              </div>
              }
              @if (isInternal || equipmentCalibration.tolerance) {
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario" matTooltip="{{'calibrationPlan.contactUs.tooltip'| translate }}"
                  [matTooltipDisabled]="hasCalibrationPlan()">
                  <mat-label>{{ 'internalEquipmentEdit.general.tolerance.label' | translate }}</mat-label>
                  <input matInput name="tolerance" [(ngModel)]="equipmentCalibration.tolerance"
                    [disabled]="!hasCalibrationPlan() || !isInternal || pendingReview">
                </mat-form-field>
              </div>
              }
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario" matTooltip="{{'calibrationPlan.contactUs.tooltip'| translate }}"
                  [matTooltipDisabled]="hasCalibrationPlan()">
                  <mat-label>{{ 'internalEquipmentEdit.general.calibrationFrequency.label' | translate }}</mat-label>
                  <input type="number" matInput name="calibrationFrequency" [(ngModel)]="equipmentCalibration.frequency"
                    required [disabled]="!hasCalibrationPlan() || pendingReview">
                </mat-form-field>
              </div>
              @if (isInternal) {
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario" matTooltip="{{'calibrationPlan.contactUs.tooltip'| translate }}"
                  [matTooltipDisabled]="hasCalibrationPlan()">
                  <mat-label>{{ 'internalEquipmentEdit.general.calibrationResponsible.label' | translate
                    }}</mat-label>
                  <mat-select name="calibrationResponsibles" [(ngModel)]="equipmentCalibration.responsible"
                    [required]="isInternal" (selectionChange)="onChangeResponsibleCheck($event, 1)"
                    [disabled]="!hasCalibrationPlan() || !isInternal || pendingReview">
                    @for (item of calibrationResponsibles; track item) {
                    <mat-option [value]="item.id">
                      {{ 'calibrationResponsibleType.' + item.translation | translate }}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              }
              @if (isInternal) {
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario" matTooltip="{{'calibrationPlan.contactUs.tooltip'| translate }}"
                  [matTooltipDisabled]="hasCalibrationPlan()">
                  <mat-label>{{ 'internalEquipmentEdit.general.supplier.label' | translate }}</mat-label>
                  <input matInput name="supplier" [(ngModel)]="equipmentCalibration.supplier"
                    [disabled]="disablesSupplier() || pendingReview">
                </mat-form-field>
              </div>
              }
              @if (isInternal) {
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'internalEquipmentEdit.general.fee.label' | translate }}</mat-label>
                  <input matInput name="fee" [(ngModel)]="equipmentCalibration.fee" type="number" min="0"
                    matTooltip="{{'calibrationPlan.contactUs.tooltip'| translate }}"
                    [matTooltipDisabled]="hasCalibrationPlan()" [disabled]="!hasCalibrationPlan() || pendingReview">
                </mat-form-field>
              </div>
              }
              @if (equipment.id) {

              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-checkbox [(ngModel)]="extendedDay" [disabled]="!hasCalibrationPlan() || pendingReview"
                  (change)="onChangeDateExpandedCheck(equipmentCalibration.idActionType, $event)"
                  [ngModelOptions]="{standalone: true}">
                  {{ 'internalEquipmentEdit.general.extendedCalibration.label' | translate }}
                </mat-checkbox>
              </div>

              <div fxFlex="50" fxFlex.lt-md="100%" *ngIf="extendedDay || equipmentCalibration.expansionDay">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'internalEquipmentEdit.general.extendedDayCalibration.label' | translate }}</mat-label>
                  <input type="number" min="0" matInput name="extendedDayCalibration"
                    [(ngModel)]="equipmentCalibration.expansionDay" [disabled]="!hasCalibrationPlan() || pendingReview"
                    (blur)="onChangeDateExpanded(equipmentCalibration.idActionType)">
                </mat-form-field>
              </div>
              }
            </div>
          </mat-expansion-panel>
          }
          @if (isVerification) {
          <mat-expansion-panel (opened)="isDataVerificationOpened = true" (closed)="isDataVerificationOpened = false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ 'internalEquipmentEdit.verificationData.title' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
              @if (isInternal || equipmentVerification.equipmentRang) {
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario" matTooltip="{{'calibrationPlan.contactUs.tooltip'| translate }}"
                  [matTooltipDisabled]="hasCalibrationPlan()">
                  <mat-label>{{ 'internalEquipmentEdit.general.equipmentRange.label' | translate }}</mat-label>
                  <input matInput name="equipmentRangeVerification" [(ngModel)]="equipmentVerification.equipmentRange"
                    [disabled]="!hasCalibrationPlan() || !isInternal || pendingReview">
                </mat-form-field>
              </div>
              }
              @if (isInternal || equipmentVerification.verificationPoint) {
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario" matTooltip="{{'calibrationPlan.contactUs.tooltip'| translate }}"
                  [matTooltipDisabled]="hasCalibrationPlan()">
                  <mat-label>{{ 'internalEquipmentEdit.general.pointVerificacion.label' | translate }}</mat-label>
                  <input matInput name="useRangeVerification" [(ngModel)]="equipmentVerification.verificationPoint"
                    [disabled]="!hasCalibrationPlan() || !isInternal || pendingReview">
                </mat-form-field>
              </div>
              }
              @if (isInternal || equipmentVerification.resolution) {
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario" matTooltip="{{'calibrationPlan.contactUs.tooltip'| translate }}"
                  [matTooltipDisabled]="hasCalibrationPlan()">
                  <mat-label>{{ 'internalEquipmentEdit.general.resolution.label' | translate }}</mat-label>
                  <input matInput name="resolutionVerification" [(ngModel)]="equipmentVerification.resolution"
                    [disabled]="!hasCalibrationPlan() || !isInternal || pendingReview">
                </mat-form-field>
              </div>
              }
              @if (isInternal || equipmentVerification.tolerance) {
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario" matTooltip="{{'calibrationPlan.contactUs.tooltip'| translate }}"
                  [matTooltipDisabled]="hasCalibrationPlan()">
                  <mat-label>{{ 'internalEquipmentEdit.general.tolerance.label' | translate }}</mat-label>
                  <input matInput name="toleranceVerification" [(ngModel)]="equipmentVerification.tolerance"
                    [disabled]="!hasCalibrationPlan() || !isInternal || pendingReview">
                </mat-form-field>
              </div>
              }
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario" matTooltip="{{'calibrationPlan.contactUs.tooltip'| translate }}"
                  [matTooltipDisabled]="hasCalibrationPlan()">
                  <mat-label>{{ 'internalEquipmentEdit.general.verificationFrequency.label' | translate }}</mat-label>
                  <input type="number" matInput name="verificationFrequency"
                    [(ngModel)]="equipmentVerification.frequency" required
                    [disabled]="!hasCalibrationPlan() || !isInternal || pendingReview">
                </mat-form-field>
              </div>
              @if (isInternal) {
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario" matTooltip="{{'calibrationPlan.contactUs.tooltip'| translate }}"
                  [matTooltipDisabled]="hasCalibrationPlan()">
                  <mat-label>{{ 'internalEquipmentEdit.general.verificationResponsible.label' | translate
                    }}</mat-label>
                  <mat-select name="verificationResponsibles" [(ngModel)]="equipmentVerification.responsible"
                    [required]="isInternal" (selectionChange)="onChangeResponsibleCheck($event, 2)"
                    [disabled]="!hasCalibrationPlan() || pendingReview">
                    @for (item of calibrationResponsibles; track item) {
                    <mat-option [value]="item.id">
                      {{ 'calibrationResponsibleType.' + item.translation | translate }}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              }
              @if (isInternal) {
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario" matTooltip="{{'calibrationPlan.contactUs.tooltip'| translate }}"
                  [matTooltipDisabled]="hasCalibrationPlan()">
                  <mat-label>{{ 'internalEquipmentEdit.general.verificationSupplier.label' | translate }}</mat-label>
                  <input matInput name="supplierVerification" [(ngModel)]="equipmentVerification.supplier"
                    [disabled]="disablesSupplier() || pendingReview">
                </mat-form-field>
              </div>
              }
              @if (isInternal) {
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'internalEquipmentEdit.general.verificationFee.label' | translate }}</mat-label>
                  <input matInput name="verificationFee" [(ngModel)]="equipmentVerification.fee" type="number" min="0"
                    matTooltip="{{'calibrationPlan.contactUs.tooltip'| translate }}"
                    [matTooltipDisabled]="hasCalibrationPlan()" [disabled]="!hasCalibrationPlan() || pendingReview">
                </mat-form-field>
              </div>
              }
              @if (equipment.id) {
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-checkbox name="selectExtendedDayVerification" [(ngModel)]="extendedDayVerification"
                  (change)="onChangeDateExpandedCheck(equipmentVerification.idActionType, $event)"
                  [ngModelOptions]="{standalone: true}" [disabled]="!hasCalibrationPlan() || pendingReview">
                  {{ 'internalEquipmentEdit.general.verification.extended.label' | translate }}
                </mat-checkbox>
              </div>

              <div fxFlex="50" fxFlex.lt-md="100%"
                *ngIf="extendedDayVerification || equipmentVerification.expansionDay">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'internalEquipmentEdit.general.verification.extendedDay.label' | translate
                    }}</mat-label>
                  <input type="number" min="0" matInput name="extendedDayVerification"
                    [(ngModel)]="equipmentVerification.expansionDay" [disabled]="!hasCalibrationPlan() || pendingReview"
                    (blur)="onChangeDateExpanded(equipmentVerification.idActionType)">
                </mat-form-field>
              </div>
              }
            </div>
          </mat-expansion-panel>
          }
          @if (isMaintenance) {
          <mat-expansion-panel hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{'internalEquipmentEdit.maintenanceData.title' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (equipment.id) {
            <div fxFlex="50" fxFlex.lt-md="100%">
              <mat-checkbox name="selectExtendedDayMaintenance" [(ngModel)]="extendedDayMaintenance"
                (change)="onChangeDateExpandedCheck(equipmentMaintenance.idActionType, $event)"
                [ngModelOptions]="{standalone: true}" [disabled]="!hasCalibrationPlan() || pendingReview">
                {{ 'internalEquipmentEdit.general.maintenance.extended.label' | translate }}
              </mat-checkbox>
            </div>

            <div fxFlex="50" fxFlex.lt-md="100%" *ngIf="extendedDayMaintenance || equipmentMaintenance.expansionDay">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'internalEquipmentEdit.general.maintenance.extendedDay.label' | translate }}</mat-label>
                <input type="number" min="0" matInput name="extendedDayMaintenance"
                  [(ngModel)]="equipmentMaintenance.expansionDay" [disabled]="!hasCalibrationPlan() || pendingReview"
                  (blur)="onChangeDateExpanded(equipmentMaintenance.idActionType)">
              </mat-form-field>
            </div>
            } @else {
            <mat-panel-description>
              {{'internalEquipmentEdit.notApplicable.dataGeneral.title' | translate}}
            </mat-panel-description>
            }
          </mat-expansion-panel>
          }
          @if (isQualification) {
          <mat-expansion-panel hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{'internalEquipmentEdit.qualificacioneData.title' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (equipment.id) {
            <div fxFlex="50" fxFlex.lt-md="100%">
              <mat-checkbox name="selectExtendedDayQualification" [(ngModel)]="extendedDayQualification"
                (change)="onChangeDateExpandedCheck(equipmentQualification.idActionType, $event)"
                [ngModelOptions]="{standalone: true}" [disabled]="!hasCalibrationPlan() || pendingReview">
                {{ 'internalEquipmentEdit.general.qualification.extended.label' | translate }}
              </mat-checkbox>
            </div>

            <div fxFlex="50" fxFlex.lt-md="100%"
              *ngIf="extendedDayQualification || equipmentQualification.expansionDay">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'internalEquipmentEdit.general.qualification.extendedDay.label' | translate }}</mat-label>
                <input type="number" min="0" matInput name="extendedDayQualification"
                  [(ngModel)]="equipmentQualification.expansionDay" [disabled]="!hasCalibrationPlan() || pendingReview"
                  (blur)="onChangeDateExpanded(equipmentQualification.idActionType)">
              </mat-form-field>
            </div>
            } @else {
            <mat-panel-description>
              {{'internalEquipmentEdit.notApplicable.dataGeneral.title' | translate}}
            </mat-panel-description>
            }
          </mat-expansion-panel>
          }
          @if (isCharacterization) {
          <mat-expansion-panel hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{'internalEquipmentEdit.characterizationData.title' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (equipment.id) {
            <div fxFlex="50" fxFlex.lt-md="100%">
              <mat-checkbox name="selectExtendedDayCharacterization" [(ngModel)]="extendedDayCharacterization"
                (change)="onChangeDateExpandedCheck(equipmentCharacterization.idActionType, $event)"
                [ngModelOptions]="{standalone: true}" [disabled]="!hasCalibrationPlan() || pendingReview">
                {{ 'internalEquipmentEdit.general.characterization.extended.label' | translate }}
              </mat-checkbox>
            </div>

            <div fxFlex="50" fxFlex.lt-md="100%"
              *ngIf="extendedDayCharacterization || equipmentCharacterization.expansionDay">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'internalEquipmentEdit.general.characterization.extendedDay.label' | translate
                  }}</mat-label>
                <input type="number" min="0" matInput name="extendedDayCharacterization"
                  [(ngModel)]="equipmentCharacterization.expansionDay" [disabled]="!hasCalibrationPlan() || pendingReview"
                  (blur)="onChangeDateExpanded(equipmentCharacterization.idActionType)">
              </mat-form-field>
            </div>
            } @else {
            <mat-panel-description>
              {{'internalEquipmentEdit.notApplicable.dataGeneral.title' | translate}}
            </mat-panel-description>
            }
          </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
    </mat-card-content>
  </mat-card>
  }

  @if (equipment.id && showMultichannel()) {
  <mat-card class="card">
    <mat-card-content>
      <mat-toolbar color="secondary">
        {{ 'internalEquipmentEdit.multichannels.title' | translate }}
        @if (equipment.id != null && canSave()) {
        <button mat-icon-button color="accent" (click)="createMultichannel()" [disabled]="pendingReview"
          matTooltip="{{ 'internalEquipmentEdit.general.add.multichannels.label' | translate }}">
          <mat-icon>add</mat-icon>
        </button>
        }
      </mat-toolbar>
      <div fxLayout="row" class="flexwrap">
        <div fxFlex fxFlex.lt-md="100%">
          <table mat-table matSort #multiChannelTable [dataSource]="equipment.multichannels" style="width: 95%;">
            <!-- code Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'internalEquipmentEdit.multichannels.values.name.label' | translate }}
              </th>
              <td mat-cell *matCellDef="let item"> {{ item.description }} </td>
            </ng-container>
            <!-- name Column -->
            <ng-container matColumnDef="active">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'internalEquipmentEdit.multichannels.values.active.label' | translate }}
              </th>
              <td mat-cell *matCellDef="let item" style="white-space: pre;">
                @if (item.active) {
                <mat-icon>
                  check
                </mat-icon>
                }
                @if (!item.active) {
                <mat-icon>
                  close
                </mat-icon>
                }
              </td>
            </ng-container>
            <!-- Button edit Column -->
            <ng-container matColumnDef="edit">
              <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' | translate }} </th>
              <td mat-cell *matCellDef="let element; let multichannelIndex = index">
                <button mat-icon-button (click)="openEditMultichannel(multichannelIndex)" [disabled]="pendingReview">
                  <mat-icon>mode_edit</mat-icon>
                </button>
              </td>
            </ng-container>
            <!-- Button delete Column -->
            <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef> {{ 'button.delete' | translate }} </th>
              <td mat-cell *matCellDef="let element; let multichannelIndex= index">
                <button mat-icon-button (click)="deleteMultichannel(multichannelIndex)" [disabled]="pendingReview">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="multichannelCols"></tr>
            <tr mat-row *matRowDef="let row; columns: multichannelCols;"></tr>
          </table>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  }

  @if ((equipment.id && (isEdit || isInternal))) {
  <mat-card class="card">
    <mat-card-content>
      <mat-toolbar color="secondary">
        {{ 'internalEquipmentEdit.equipment.title' | translate }}
        @if (equipment.id != null && canSave()) {
        <button mat-icon-button color="accent" (click)="newExternalCalibration()" [disabled]="pendingReview"
          matTooltip="{{ 'internalEquipmentEdit.register.body.title.create' | translate }}">
          <mat-icon>add</mat-icon>
        </button>
        }
      </mat-toolbar>
      @if (!calibrations || calibrations?.length == 0) {
      <div>
        {{ 'common.noResults' | translate }}
      </div>
      }
      <mat-accordion>
        @for (calibration of calibrations; track calibration; let indexCalibration = $index) {
        <mat-expansion-panel (opened)="setCalibrationOpened(indexCalibration, true)"
          [expanded]="isCalibrationOpened(indexCalibration)" (closed)="setCalibrationOpened(indexCalibration, false)">
          <mat-expansion-panel-header>
            <mat-panel-title>
              @if (isNotValid(calibration)) {
              <mat-icon color="warn">close</mat-icon>
              }
              {{ (calibration.actionType === 1 ? 'internalEquipmentEdit.calibrations.title.title' :
              calibration.actionType === 2 ? 'internalEquipmentEdit.verification.title.title' :
              calibration.actionType === 3 ? 'internalEquipmentEdit.maintenance.title.title':
              calibration.actionType === 4 ? 'internalEquipmentEdit.qualificacion.title.title' :
              calibration.actionType === 5 ? 'internalEquipmentEdit.characterization.title.title' : '') | translate : {
              date: (calibration.calibrationDate | fixDate) } }}
              ({{calibration.internal ? ('common.internal' | translate) : ('common.external' | translate)}})
              @if (isCalibrationOpened(indexCalibration)) {
              <div fxFlex="50" class="container-btn-crud">
                @if (!calibration.internal) {
                <button mat-icon-button (click)="editExternalCalibration(indexCalibration)" color="accent"
                  [disabled]="pendingReview"
                  matTooltip="{{ 'internalEquipmentEdit.register.body.title.edit' | translate }}" class="centerButton">
                  <mat-icon>mode_edit</mat-icon>
                </button>
                }
                @if (calibration.internal) {
                <button mat-icon-button (click)="goToCalibration(calibration.id, calibration.actionType)" color="accent"
                  matTooltip="{{ 'internalEquipmentEdit.register.body.title.edit' | translate }}" class="centerButton">
                  <mat-icon>mode_edit</mat-icon>
                </button>
                }
                @if (!calibration.internal) {
                <button mat-icon-button (click)="deleteExternalCalibrationWithReason(calibration.id, indexCalibration)" color="accent"
                  [disabled]="pendingReview"
                  matTooltip="{{ 'internalEquipmentEdit.register.body.title.delete' | translate }}"
                  class="centerButton">
                  <mat-icon>delete</mat-icon>
                </button>
                }
                @if (calibration.idDocument != null || calibration.idCertificate != null) {
                <button mat-icon-button (click)="downloadCertificateEquipment(indexCalibration)" color="accent"
                  matTooltip="{{ 'button.download-certificate' | translate }}" class="centerButton">
                  <mat-icon>cloud_download</mat-icon>
                </button>
                }
                @if (calibration.internal && calibration.idDocument == null && calibration.idCertificate == null) {
                <button mat-icon-button (click)="downloadCertificateLastCertificateCalibration(indexCalibration)"
                  color="accent" matTooltip="{{ 'button.download-certificate' | translate }}" class="centerButton">
                  <mat-icon>cloud_download</mat-icon>
                </button>
                }
                @if (equipment.id != null) {
                <button mat-icon-button (click)="uploadCertificateCalibration.click()" color="accent"
                  [disabled]="pendingReview" matTooltip="{{ 'button.upload-certificate' | translate }}"
                  class="centerButton">
                  <mat-icon>cloud_upload</mat-icon>
                </button>
                }
                @if (isInternal && equipment.id != null && (calibration.idCertificate != null || calibration.idDocument
                != null)) {
                <button mat-icon-button (click)="deleteCertificateToCalibration(indexCalibration)" color="accent"
                  [disabled]="pendingReview" matTooltip="{{ 'button.delete-certificate' | translate }}"
                  class="centerButton">
                  <mat-icon>cloud_off</mat-icon>
                </button>
                }
              </div>
              }
              <input accept="application/pdf" hidden type="file"
                (change)="uploadCertificateToCalibration(indexCalibration, $event)" #uploadCertificateCalibration>
            </mat-panel-title>
            <mat-panel-description fxFlex="50">
              {{ (calibration.actionType === 1 ? (calibration.regUser ?
              'internalEquipmentEdit.calibrations.title.subtitle' :
              'internalEquipmentEdit.calibrations.without.user.title.subtitle'):
              calibration.actionType === 2 ? (calibration.regUser ? 'internalEquipmentEdit.verification.title.subtitle':
              'internalEquipmentEdit.verification.without.user.title.subtitle'):
              calibration.actionType === 3 ? (calibration.regUser ? 'internalEquipmentEdit.maintenance.title.subtitle':
              'internalEquipmentEdit.maintenance.without.user.title.subtitle'):
              calibration.actionType === 4 ? (calibration.regUser ?
              'internalEquipmentEdit.qualificacion.title.subtitle':
              'internalEquipmentEdit.qualificacion.without.user.title.subtitle'):
              calibration.actionType === 5 ? (calibration.regUser ?
              'internalEquipmentEdit.characterization.title.subtitle' :
              'internalEquipmentEdit.characterization.without.user.title.subtitle'):'') | translate: {
              certificateNum:
              calibration.certificateNum, regUser: calibration.regUser} }}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div fxLayout="column">
            <span fxFlex>{{ calibration.actionType === 1 ? ('internalEquipmentEdit.calibrations.body.calibrationDate' |
              translate) :
              calibration.actionType === 2 ? ('internalEquipmentEdit.verification.body.calibrationDate' | translate) :
              calibration.actionType === 3 ? ('internalEquipmentEdit.maintenance.body.calibrationDate' | translate) :
              calibration.actionType === 4 ? ('internalEquipmentEdit.qualificacion.body.calibrationDate' | translate) :
              calibration.actionType === 5 ? ('internalEquipmentEdit.characterization.body.calibrationDate' | translate)
              : '' }}:
              {{ calibration.calibrationDate | fixDate }}</span>
            <span fxFlex>{{ calibration.actionType === 1 ? ('internalEquipmentEdit.calibrations.body.expirationDate' |
              translate ) :
              calibration.actionType === 2 ? ('internalEquipmentEdit.verification.body.expirationDate' | translate) :
              calibration.actionType === 3 ? ('internalEquipmentEdit.maintenance.body.expirationDate' | translate) :
              calibration.actionType === 4 ? ('internalEquipmentEdit.qualificacion.body.expirationDate' | translate) :
              calibration.actionType === 5 ? ('internalEquipmentEdit.characterization.body.expirationDate' | translate)
              :''}}:
              {{ calibration.expirationDate | fixDate }}</span>
            @if (calibration.certificateNum ) {
            <span fxFlex>{{
              calibration.actionType === 4 ?
              ('internalEquipmentEdit.qualificacion.body.certificateNum' | translate) :
              calibration.actionType === 5 ?
              ('internalEquipmentEdit.characterization.body.certificateNum' | translate) :
              ('internalEquipmentEdit.calibrations.body.certificateNum' | translate) }}:
              {{ calibration.certificateNum }}</span>
            }
            @if (calibration.executionNum ) {
            <span fxFlex>{{ calibration.actionType === 4 ?
              ('internalEquipmentEdit.qualificacion.body.executionNum' | translate) :
              ('internalEquipmentEdit.calibrations.body.certificateNum' | translate) }}:
              {{ calibration.executionNum }}</span>
            }
          </div>
          @if (calibration.internal) {
          <span>
            <br />
          </span>
          }
          @if (calibration.actionType === 1) {
          <div fxLayout="column">
            @if (calibration.internal) {
            <span fxFlex>
              {{ 'internalEquipmentEdit.calibrations.body.temperature' | translate }}:
              {{ calibration.temperature != null ? calibration.temperature : ('common.notApplicable' | translate) }}
            </span>
            }
            @if (calibration.internal) {
            <span fxFlex>
              {{ 'internalEquipmentEdit.calibrations.body.humidity' | translate }}:
              {{ calibration.humidity != null ? calibration.humidity : ('common.notApplicable' | translate) }}
            </span>
            }
            @if (calibration.internal) {
            <span fxFlex>
              {{ 'internalEquipmentEdit.calibrations.body.pressure' | translate }}:
              {{ calibration.pressure != null ? calibration.pressure : ('common.notApplicable' | translate) }}
            </span>
            }
          </div>
          }
          @if (calibration.actionType === 1) {
          <div fxLayout="column">
            @for (variable of calibration.variables; track variable) {
            <div>
              <br />
              <strong>
                {{ 'internalEquipmentEdit.calibrations.body.results.title' | translate: { variable: ('variable.' +
                variable.variableTranslation | translate), measurementUnit: variable.unitName ? variable.unitName : ''}
                }}
              </strong>
              @if (!calibration.multichannel) {
              <div>
                <table #asLeftTable mat-table
                  [dataSource]="calibration.internal ? getAsLeftList(variable) : variable.values" style="width: 100%;">
                  <!-- Number Column -->
                  <ng-container matColumnDef="number">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element; let i = index"> {{ (i + 1) }} </td>
                  </ng-container>
                  <!-- Point Column -->
                  <ng-container matColumnDef="point">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ 'calibrateEquipmentEdit.asLeft.cols.point.label' | translate }} </th>
                    <td mat-cell *matCellDef="let element"> {{ element.point }} </td>
                  </ng-container>
                  <!-- idMass Column -->
                  @if (isBalance) {
                  <ng-container matColumnDef="idMass">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ 'calibrateEquipmentEdit.asLeft.cols.idMass.label' | translate }} </th>
                    <td mat-cell *matCellDef="let element"> {{ element.idMass ? element.idMass : '-'}} </td>
                  </ng-container>
                  }
                  <!-- Pattern Column -->
                  <ng-container matColumnDef="pattern">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ 'calibrateEquipmentEdit.asLeft.cols.physical.label' | translate }} </th>
                    <td mat-cell *matCellDef="let element"> {{ calibration.internal ? element.pattern : null }} </td>
                  </ng-container>
                  <!-- Average Column -->
                  <ng-container matColumnDef="average">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ isBalance ? ('calibrateEquipmentEdit.asLeft.cols.pattern.label' | translate ):
                      ('calibrateEquipmentEdit.asLeft.cols.average.label' | translate) }} </th>
                    <td mat-cell *matCellDef="let element">
                      <span [matTooltip]="isBalance ? element.pattern : element.average">
                        {{ calibration.internal ?
                        ( element.average | number:'1.' + (getDecimalsResolution(variable.resolution) + 1) + '-' +
                        (getDecimalsResolution(variable.resolution) + 1) ) :
                        (isBalance ? element.pattern : element.average) }}
                      </span>
                    </td>
                  </ng-container>
                  <!-- Correction Column -->
                  <ng-container matColumnDef="correction">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ 'calibrateEquipmentEdit.asLeft.cols.correction.label' | translate }} </th>
                    <td mat-cell *matCellDef="let element">
                      {{ calibration.internal ?
                      ( element.correction | number:'1.' + getDecimalsPattern(element.pattern) + '-' +
                      getDecimalsPattern(element.pattern) ) :
                      (element.correction | number:'1.' + getDecimalsPattern(element.pattern) + '-' +
                      getDecimalsPattern(element.pattern)) }}
                    </td>
                  </ng-container>
                  <!-- U Column -->
                  <ng-container matColumnDef="U">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ 'calibrateEquipmentEdit.uncertainties.cols.U.label' | translate }} </th>
                    <td mat-cell *matCellDef="let element">
                      {{ calibration.internal ?
                      ( element.U | number:'1.' + getDecimalsUncertainty(element.uncertaintyResolution) + '-' +
                      getDecimalsUncertainty(element.uncertaintyResolution) ) :
                      (element.uncertainty | smartNumber) }}
                    </td>
                  </ng-container>
                  <tr mat-header-row
                    *matHeaderRowDef="(isBalance ? asLeftColsMass: (calibration.internal ? asLeftColsInt : asLeftColsExt))">
                  </tr>
                  <tr mat-row
                    *matRowDef="let row; columns: (isBalance ? asLeftColsMass: (calibration.internal ? asLeftColsInt : asLeftColsExt))">
                  </tr>
                </table>
              </div>
              }
              @if (calibration.multichannel) {
              <div>
                <mat-card>
                  <mat-card-content>
                    <mat-tab-group style="width: 100%;">
                      @for (multichannel of variable.valuesMultichannel; track multichannel; let indexChannel = $index)
                      {
                      <mat-tab style="min-height: 50vh;" label="{{ multichannel.description }}">
                        <mat-card class="card">
                          <mat-card-content>
                            <div fxLayout="column" class="flexwrap">
                              <div fxFlex>
                                <table #asLeftTableMultiChannel mat-table
                                  [dataSource]="getAsLeftListMultichannel(variable, indexChannel)" style="width: 100%;">
                                  <!-- Number Column -->
                                  <ng-container matColumnDef="number">
                                    <th mat-header-cell *matHeaderCellDef> </th>
                                    <td mat-cell *matCellDef="let element; let i = index"> {{ (i + 1) }} </td>
                                  </ng-container>
                                  <!-- Point Column -->
                                  <ng-container matColumnDef="point">
                                    <th mat-header-cell *matHeaderCellDef>
                                      {{ 'calibrateEquipmentEdit.asLeft.cols.point.label' | translate }} </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.point }} </td>
                                  </ng-container>
                                  <!-- Pattern Column -->
                                  <ng-container matColumnDef="pattern">
                                    <th mat-header-cell *matHeaderCellDef>
                                      {{ 'calibrateEquipmentEdit.asLeft.cols.pattern.label' | translate }} </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.pattern }} </td>
                                  </ng-container>
                                  <!-- Values Column -->
                                  <ng-container matColumnDef="value">
                                    <th mat-header-cell *matHeaderCellDef>
                                      {{ 'calibrateEquipmentEdit.asLeft.cols.value.label' | translate }} </th>
                                    <td mat-cell *matCellDef="let element"> {{ joinListValues(indexVariable, element) }}
                                    </td>
                                  </ng-container>
                                  <!-- Average Column -->
                                  <ng-container matColumnDef="average">
                                    <th mat-header-cell *matHeaderCellDef>
                                      {{ 'calibrateEquipmentEdit.asLeft.cols.average.label' | translate }} </th>
                                    <td mat-cell *matCellDef="let element">
                                      <span [matTooltip]="element.average">
                                        {{ element.average | number:'1.' + (getDecimalsResolution(variable.resolution) +
                                        1) + '-' +
                                        (getDecimalsResolution(variable.resolution) + 1) }}
                                      </span>
                                    </td>
                                  </ng-container>
                                  <!-- Correction Column -->
                                  <ng-container matColumnDef="correction">
                                    <th mat-header-cell *matHeaderCellDef>
                                      {{ 'calibrateEquipmentEdit.asLeft.cols.correction.label' | translate }} </th>
                                    <td mat-cell *matCellDef="let element">
                                      <span [matTooltip]="element.correction">
                                        {{ element.correction | number:'1.' + getDecimalsPattern(element.pattern) + '-'
                                        +
                                        getDecimalsPattern(element.pattern) }}
                                      </span>
                                    </td>
                                  </ng-container>
                                  <!-- U Column -->
                                  <ng-container matColumnDef="U">
                                    <th mat-header-cell *matHeaderCellDef>
                                      {{ 'calibrateEquipmentEdit.uncertainties.cols.U.label' | translate }} </th>
                                    <td mat-cell *matCellDef="let element">
                                      <span [matTooltip]="element.U">
                                        {{element.U | number:'1.' +
                                        getDecimalsUncertainty(element.uncertaintyResolution) + '-' +
                                        getDecimalsUncertainty(element.uncertaintyResolution)}}
                                      </span>
                                    </td>
                                  </ng-container>
                                  <tr mat-header-row *matHeaderRowDef="asLeftColsInt"></tr>
                                  <tr mat-row *matRowDef="let row; columns: asLeftColsInt;"></tr>
                                </table>
                              </div>
                            </div>
                          </mat-card-content>
                        </mat-card>
                      </mat-tab>
                      }
                    </mat-tab-group>
                  </mat-card-content>
                </mat-card>
              </div>
              }
            </div>
            }
          </div>
          }
        </mat-expansion-panel>
        }
      </mat-accordion>
    </mat-card-content>
  </mat-card>
  }

  <mat-card class="card">
    <mat-card-content>
      <mat-toolbar color="secondary">
        {{ 'internalEquipmentEdit.observations.title' | translate }}
      </mat-toolbar>

      <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
        <div fxFlex="100" fxFlex.lt-md="100%">
          <textarea matInput rows="8" [(ngModel)]="equipment.observations" name="observations" style="resize: none;">
        </textarea>
        </div>
      </div>

    </mat-card-content>
  </mat-card>

  @if (isEdit || isInternal) {
  <mat-card class="card">
    <mat-card-content>
      <mat-toolbar color="secondary">
        {{ 'internalEquipmentEdit.status.title' | translate }}
      </mat-toolbar>
      @if (isEdit || isInternal) {
      <div fxLayout="column" fxLayout.xs="column" class="flexwrap">
        <div fxLayout="row" class="status-action-title">
          <div fxFlex="20">
            <span></span>
          </div>
          <div fxFlex="20" style="text-align: center;">
            <span>{{'internalEquipmentEdit.status.certificate.title' | translate}}</span>
          </div>
          <div fxFlex="20" style="text-align: center;">
            <span>{{'internalEquipmentEdit.status.realizationDate.title' | translate}}</span>
          </div>
          <div fxFlex="20" style="text-align: center;">
            <span>{{'internalEquipmentEdit.status.nextDate.title' | translate}}</span>
          </div>
          <div fxFlex="20" style="text-align: center;">
            <span>{{'internalEquipmentEdit.status.dateExpired.title' | translate}}</span>
          </div>
          <div fxFlex="20" style="text-align: center;">
            <span>{{'internalEquipmentEdit.status.actionStaus.title' | translate}}</span>
          </div>
          <div fxFlex="5" style="text-align: center;"></div>
          <div fxFlex="5" style="text-align: center;"></div>
        </div>
        @if (isCalibration && equipmentCalibration) {
        <div class="status-action">
          <div fxFlex="20" [ngClass]="highlight(equipmentCalibration)">
            <span>{{'internalEquipmentEdit.status.calibration.title' | translate}}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentCalibration)">
            <span>{{equipmentCalibration.documentNumber ? equipmentCalibration.documentNumber: '--'}}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentCalibration)">
            <span>{{equipmentCalibration.documentNumber ? (equipmentCalibration.processDate | fixDate) :
              '--'}}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentCalibration)">
            <span>{{ getDatePerformances(equipmentCalibration) | fixDate }}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentCalibration)">
            <span>{{equipmentCalibration.documentNumber ? (calculateNextActivity(1) | fixDate) :
              (equipmentCalibration.expirationDate | fixDate) }}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentCalibration)">
            <span>{{descriptionStatusActions(equipmentCalibration.idStatus)}}</span>
          </div>
          <div fxFlex="5">
            @if (equipmentCalibration.idCertificate != null) {
            <button mat-icon-button color="accent" class="centerButton"
              (click)="downloadPdfActions(equipmentCalibration)"
              matTooltip="{{ 'button.download-certificate' | translate }}">
              <mat-icon>cloud_download</mat-icon>
            </button>
            }
          </div>
          <div fxFlex="5">
            @if ((!equipmentCalibration.id && equipmentCalibration.processDate) || (equipmentCalibration.processDate &&
            canSave())) {
            <button mat-icon-button (click)="editAndDeleteRowPerfomances(1, true)"
              matTooltip="{{ 'button.edit' | translate }}">
              <mat-icon>mode_edit</mat-icon>
            </button>
            }
          </div>
        </div>
        }
        @if (isVerification && equipmentVerification) {
        <div class="status-action">
          <div fxFlex="20" [ngClass]="highlight(equipmentVerification)">
            <span>{{'internalEquipmentEdit.status.verification.title' | translate}}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentVerification)">
            <span>{{equipmentVerification.documentNumber ? equipmentVerification.documentNumber: '--' }}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentVerification)">
            <span>{{equipmentVerification.documentNumber ? (equipmentVerification.processDate | fixDate):
              '--'}}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentVerification)">
            <span>{{ getDatePerformances(equipmentVerification) | fixDate }}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentVerification)">
            <span>{{equipmentVerification.documentNumber ? (calculateNextActivity(2) | fixDate) :
              (equipmentVerification.expirationDate | fixDate) }}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentVerification)">
            <span>{{descriptionStatusActions(equipmentVerification.idStatus)}}</span>
          </div>
          <div fxFlex="5">
            @if (equipmentVerification.idCertificate != null) {
            <button mat-icon-button color="accent" class="centerButton"
              (click)="downloadPdfActions(equipmentVerification)"
              matTooltip="{{ 'button.download-certificate' | translate }}">
              <mat-icon>cloud_download</mat-icon>
            </button>
            }
          </div>
          <div fxFlex="5">
            @if ((!equipmentVerification.id && equipmentVerification.processDate) || (equipmentVerification.processDate
            && canSave())) {
            <button mat-icon-button (click)="editAndDeleteRowPerfomances(2, true)"
              matTooltip="{{ 'button.edit' | translate }}">
              <mat-icon>mode_edit</mat-icon>
            </button>
            }
          </div>
        </div>
        }
        @if (isMaintenance && equipmentMaintenance) {
        <div class="status-action">
          <div fxFlex="20" [ngClass]="highlight(equipmentMaintenance)">
            <span>{{'internalEquipmentEdit.status.maintenance.title' | translate}}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentMaintenance)">
            <span>{{equipmentMaintenance.documentNumber ? equipmentMaintenance.documentNumber: '--' }}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentMaintenance)">
            <span>{{equipmentMaintenance.documentNumber ? (equipmentMaintenance.processDate | fixDate) :
              '--'}}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentMaintenance)">
            <span>{{getDatePerformances(equipmentMaintenance) | fixDate }}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentMaintenance)">
            <span>{{equipmentMaintenance.documentNumber ? (calculateNextActivity(3) | fixDate) :
              (equipmentMaintenance.expirationDate | fixDate) }}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentMaintenance)">
            <span>{{descriptionStatusActions(equipmentMaintenance.idStatus)}}</span>
          </div>
          <div fxFlex="5">
            @if (equipmentMaintenance.idCertificate != null) {
            <button mat-icon-button color="accent" class="centerButton"
              (click)="downloadPdfActions(equipmentMaintenance)"
              matTooltip="{{ 'button.download-certificate' | translate }}">
              <mat-icon>cloud_download</mat-icon>
            </button>
            }
          </div>
          <div fxFlex="5">
            @if ((!equipmentMaintenance.id && equipmentMaintenance.processDate) || (equipmentMaintenance.processDate &&
            canSave())) {
            <button mat-icon-button (click)="editAndDeleteRowPerfomances(3, true)"
              matTooltip="{{ 'button.edit' | translate }}">
              <mat-icon>mode_edit</mat-icon>
            </button>
            }
          </div>
        </div>
        }
        @if (isQualification && equipmentQualification) {
        <div class="status-action">
          <div fxFlex="20" [ngClass]="highlight(equipmentQualification)">
            <span>{{'internalEquipmentEdit.status.qualificacion.title' | translate}}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentQualification)">
            <span>{{equipmentQualification.documentNumber ? equipmentQualification.documentNumber : '--' }}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentQualification)">
            <span>{{equipmentQualification.documentNumber ? (equipmentQualification.processDate | fixDate) :
              '--'}}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentQualification)">
            <span>{{getDatePerformances(equipmentQualification) | fixDate }}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentQualification)">
            <span>{{equipmentQualification.documentNumber ? (calculateNextActivity(4) | fixDate) :
              (equipmentQualification.expirationDate | fixDate) }}</span>
          </div>
          <div fxFlex="20" [ngClass]="highlight(equipmentQualification)">
            <span>{{descriptionStatusActions(equipmentQualification.idStatus)}}</span>
          </div>
          <div fxFlex="5">
            @if (equipmentQualification.idCertificate != null) {
            <button mat-icon-button color="accent" class="centerButton"
              (click)="downloadPdfActions(equipmentQualification)"
              matTooltip="{{ 'button.download-certificate' | translate }}">
              <mat-icon>cloud_download</mat-icon>
            </button>
            }
          </div>
          <div fxFlex="5">
            @if ((!equipmentQualification.id && equipmentQualification.processDate) ||
            (equipmentQualification.processDate && canSave())) {
            <button mat-icon-button (click)="editAndDeleteRowPerfomances(4, true)"
              matTooltip="{{ 'button.edit' | translate }}">
              <mat-icon>mode_edit</mat-icon>
            </button>
            }
          </div>
        </div>
        }
        @if (isCharacterization && equipmentCharacterization) {
        <div class="status-action">
          <div [ngClass]="highlight(equipmentCharacterization)" fxFlex="20">
            <span>{{'internalEquipmentEdit.status.characterization.title' | translate}}</span>
          </div>
          <div [ngClass]="highlight(equipmentCharacterization)" fxFlex="20">
            <span>{{equipmentCharacterization.documentNumber ? equipmentCharacterization.documentNumber : '--'}}</span>
          </div>
          <div [ngClass]="highlight(equipmentCharacterization)" fxFlex="20">
            <span>{{equipmentCharacterization.documentNumber ? (equipmentCharacterization.processDate | fixDate) :
              '--'}}</span>
          </div>
          <div [ngClass]="highlight(equipmentCharacterization)" fxFlex="20">
            <span>{{getDatePerformances(equipmentCharacterization) | fixDate }}</span>
          </div>
          <div [ngClass]="highlight(equipmentCharacterization)" fxFlex="20">
            <span>{{equipmentCharacterization.documentNumber ? (calculateNextActivity(5) | fixDate) :
              (equipmentCharacterization.expirationDate | fixDate) }}</span>
          </div>
          <div [ngClass]="highlight(equipmentCharacterization)" fxFlex="20">
            <span>{{descriptionStatusActions(equipmentCharacterization.idStatus)}}</span>
          </div>
          <div fxFlex="5">
            @if (equipmentCharacterization.idCertificate != null) {
            <button mat-icon-button color="accent" class="centerButton"
              (click)="downloadPdfActions(equipmentCharacterization)"
              matTooltip="{{ 'button.download-certificate' | translate }}">
              <mat-icon>cloud_download</mat-icon>
            </button>
            }
          </div>
          <div fxFlex="5">
            @if ((!equipmentCharacterization.id && equipmentCharacterization.processDate) ||
            (equipmentCharacterization.processDate && canSave())) {
            <button mat-icon-button (click)="editAndDeleteRowPerfomances(5, true)"
              matTooltip="{{ 'button.edit' | translate }}">
              <mat-icon>mode_edit</mat-icon>
            </button>
            }
          </div>
        </div>
        }
      </div>
      }
    </mat-card-content>
  </mat-card>
  }

  <mat-card class="card">
    <mat-card-actions>
      <div fxFlex></div>
      @if (pendingReview) {
      <button mat-raised-button color="primary" (click)="reviewEquipment()">
        {{ 'button.approve' | translate }}</button>
      }
      @if (pendingReview) {
      <div fxFlex="1"></div>
      }
      @if (pendingReview) {
      <button mat-raised-button color="primary" (click)="decline()">
        {{ 'button.decline' | translate }}</button>
      }
      @if (canSave()) {
      <div fxFlex="1"></div>
      }
      @if (canSave()) {
      <button mat-raised-button color="primary" (click)="saveEquipment()">
        {{ 'button.save' | translate }}</button>
      }
      @if (equipment.id != null) {
      <div fxFlex="1"></div>
      }
      @if (equipment.id != null) {
      <button mat-raised-button color="accent" (click)="downloadAuditPdf()">
        {{ 'button.download-audit' | translate }}</button>
      }
      <div fxFlex="1"></div>
      <button mat-raised-button color="secondary" (click)="cancel()">{{ 'button.cancel' | translate }}</button>
    </mat-card-actions>
  </mat-card>
</form>